// extracted by mini-css-extract-plugin
module.exports = {"avatar":"CheckinRecognitionTable_avatar__14deD"};